import { useEffect, useState } from "react";
import axios from "axios";

import "./AdminSolicitacoes.css";
import ModalCadastro from "./ModalCadastro/ModalCadastro";

export default function AdminSolicitacoes() {
  const [loading, setLoading] =
    useState(true);

  const [cadastros, setCadastros] =
    useState([]);

  const [cadastroSelecionado, setCadastroSelecionado] =
    useState(null);

  useEffect(() => {
    carregarCadastros();
  }, []);

  async function carregarCadastros() {
    try {
      setLoading(true);

      const res =
        await axios.get(
          "https://app.eliandroalimentos.com.br/api/novocadastro/listar"
        );

      const lista =
        [...res.data].sort((a, b) => b.id - a.id);

      setCadastros(lista);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }

  function formatarData(data) {
    if (!data) return "-";

    const partes = data.split("-");

    if (partes.length !== 3) {
      return "-";
    }

    return `${partes[2]}/${partes[1]}/${partes[0]}`;
  }


  async function alterarNovo(id) {
  try {

    await axios.put(
      "https://app.eliandroalimentos.com.br/api/novocadastro/editar",
      {
        id,
        novo: "não"
      }
    );

    setCadastros((anterior) =>
      anterior.map((item) =>
        item.id === id
          ? { ...item, novo: "não" }
          : item
      )
    );

    if (
      cadastroSelecionado &&
      cadastroSelecionado.id === id
    ) {
      setCadastroSelecionado({
        ...cadastroSelecionado,
        novo: "não"
      });
    }

  } catch (err) {
    console.error(err);
  }
}

async function alterarStatus(
  id,
  status
) {
  try {

    await axios.put(
      "https://app.eliandroalimentos.com.br/api/novocadastro/editar",
      {
        id,
        status
      }
    );

    setCadastros((anterior) =>
      anterior.map((item) =>
        item.id === id
          ? { ...item, status }
          : item
      )
    );

    if (
      cadastroSelecionado &&
      cadastroSelecionado.id === id
    ) {
      setCadastroSelecionado({
        ...cadastroSelecionado,
        status
      });
    }

  } catch (err) {
    console.error(err);
  }
}

  if (loading) {
    return (
      <div className="adminsolicitacoes-loading">

        <div className="adminsolicitacoes-spinner" />

        <span>
          Carregando solicitações...
        </span>

      </div>
    );
  }

  return (
    <div className="adminsolicitacoes-container">

      <h1 className="adminsolicitacoes-title">
        Solicitações Cadastrais
      </h1>

      <div className="adminsolicitacoes-card">

        <table className="adminsolicitacoes-table">

          <thead>

            <tr>

              <th>Cliente</th>

              <th>Data</th>

              <th>Cidade</th>

              <th>Novo</th>

              <th>Status</th>

            </tr>

          </thead>

          <tbody>

            {cadastros.map((cadastro) => (

              <tr
                key={cadastro.id}
                onClick={() =>
                  setCadastroSelecionado(cadastro)
                }
                style={{
                  cursor: "pointer"
                }}
              >

                <td>
                  {cadastro.razaosocial ||
                    cadastro.nomecliente ||
                    "-"}
                </td>

                <td>
                  {formatarData(
                    cadastro.dtcadastro
                  )}
                </td>

                <td>
                  {cadastro.cidade || "-"}
                </td>

                <td>

  {cadastro.novo === "sim" ? (

    <span
      className="adminsolicitacoes-novo"
      onClick={(e) => {
        e.stopPropagation();
        alterarNovo(cadastro.id);
      }}
    >
      SIM
    </span>

  ) : (

    "não"

  )}

</td>

                <td>

  <select
    className="adminsolicitacoes-select"
    value={cadastro.status || "Aguardando"}
    onClick={(e) => e.stopPropagation()}
    onChange={(e) =>
      alterarStatus(
        cadastro.id,
        e.target.value
      )
    }
  >
    <option value="Aguardando">
      Aguardando
    </option>

    <option value="Pendente">
      Pendente
    </option>

    <option value="Finalizado">
      Finalizado
    </option>

  </select>

</td>

              </tr>

            ))}

          </tbody>

        </table>

      </div>

      {cadastroSelecionado && (

        <ModalCadastro
  cadastro={cadastroSelecionado}
  onClose={() =>
    setCadastroSelecionado(null)
  }
  onAtualizar={(id, alteracoes) => {

    setCadastros((anterior) =>
      anterior.map((item) =>
        item.id === id
          ? {
              ...item,
              ...alteracoes
            }
          : item
      )
    );

    setCadastroSelecionado((anterior) =>
      anterior
        ? {
            ...anterior,
            ...alteracoes
          }
        : anterior
    );

  }}
/>

      )}

    </div>
  );
}